/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespDesignTiles_itemSearch = {
    readonly displayUriRef: string | null;
    readonly creatorDesignTiles: ReadonlyArray<{
        readonly displayName: string | null;
        readonly imageUrl: string | null;
        readonly linkData: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespDesignsDescriptionTile_itemSearch">;
    readonly " $refType": "SbRespDesignTiles_itemSearch";
};
export type SbRespDesignTiles_itemSearch$data = SbRespDesignTiles_itemSearch;
export type SbRespDesignTiles_itemSearch$key = {
    readonly " $data"?: SbRespDesignTiles_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespDesignTiles_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespDesignTiles_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorDesignTiles",
      "kind": "LinkedField",
      "name": "creatorDesignTiles",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespDesignsDescriptionTile_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'c735b8935d8e17bfd8540f0c10b8f845';
export default node;
